import pages from './pages';
import views from './views';
import components from './components';
import common from './common';
import routes from './routes';

const en = {
  ...pages,
  views,
  components,
  common,
  routes,
};

export default en;
